import { useDataTypesHooks, useDescribeHooks } from "../../../../../features/data-types"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { DetailFieldProps, DetailPanel, FieldType, FormatType, UIPermission, useGetCrumbs } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { CompanyUserName, useSystemStateHooks } from "../../../../system"
import { Vehicle } from "../../../state/types"
import { useMeasureHooks, MeasuresTable } from "../../../../common"

export const VehicleDetail = () => {
  const { dataType } = useRoutesHooks().parseUrl()
  const vehicle = dataType! as Vehicle
  const { weight, maxLoadWeight, loadMeasures, ...data } = vehicle

  const { userHasPermission } = useSystemStateHooks()
  const readOnly = !userHasPermission(UIPermission.SAVE_VEHICLES) || vehicle.archived
  const { formatCustomValue, formatDateTime } = useDataTypesHooks()
  const { describe } = useDescribeHooks()
  const { describeMeasure } = useMeasureHooks()

  const title = describe(TableName.VEHICLES, vehicle)
  const plate = formatCustomValue(vehicle.plate, FormatType.PLATE)
  const crumbs = useGetCrumbs(
    'Vehículos',
    RoutePath.VEHICLES,
    plate
  )

  const fields: DetailFieldProps[] = [
    {
      name: 'name',
      type: FieldType.TEXT,
      label: 'Nombre'
    },
    {
      name: 'plate',
      type: FieldType.TEXT,
      label: 'Patente',
      render: () => <>{plate}</>
    },
    {
      name: 'weight',
      type: FieldType.NUMBER,
      label: 'Peso',
      render: () => <>{describeMeasure(vehicle.weight)}</>
    },
    {
      name: 'maxLoadWeight',
      type: FieldType.NUMBER,
      label: 'Carga Máxima',
      render: () => <>{describeMeasure(vehicle.maxLoadWeight)}</>
    },
  ]
  if (vehicle.loadMeasures.length > 0) {
    const loadMeasuresField: DetailFieldProps = {
      name: 'loadMeasures',
      type: FieldType.TABLE,
      label: '',
      render: () => (
        <MeasuresTable
          title="Medidas"
          rows={vehicle.loadMeasures}
          space={6}
          readOnly
        />
      )
    }
    fields.push(loadMeasuresField)
  }

  if (vehicle.negativeStateUserId) {
    fields.push({
      name: 'negativeStateUserId',
      type: FieldType.TEXT,
      label: 'Archivado por',
      render: () => {
        const dateStr = vehicle.negativeStateAt ? ` - ${formatDateTime(new Date(vehicle.negativeStateAt))}` : ''
        return <><CompanyUserName userId={vehicle.negativeStateUserId!} />{dateStr}</>
      }
    })
  }

  return (<>
    <DetailPanel
      title={title}
      tableName={TableName.VEHICLES}
      crumbs={crumbs}
      fields={fields}
      data={data}
      icon='truck'
      readOnly={readOnly}
    />
  </>)
}
